export default () => (
  /**
   * Ícone geralmente utilizado como "área de arrasto"
   * de itens.
   */
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.367188"
      y="0.0800781"
      width="2.38249"
      height="2.38249"
      rx="0.5"
      fill="#666666"
    />
    <rect
      x="0.367188"
      y="4.46289"
      width="2.38249"
      height="2.38249"
      rx="0.5"
      fill="#666666"
    />
    <rect
      x="0.367188"
      y="8.8457"
      width="2.38249"
      height="2.38249"
      rx="0.5"
      fill="#666666"
    />
    <rect
      x="4.75"
      y="0.0800781"
      width="2.38249"
      height="2.38249"
      rx="0.5"
      fill="#666666"
    />
    <rect
      x="4.75"
      y="4.46289"
      width="2.38249"
      height="2.38249"
      rx="0.5"
      fill="#666666"
    />
    <rect
      x="4.75"
      y="8.8457"
      width="2.38249"
      height="2.38249"
      rx="0.5"
      fill="#666666"
    />
  </svg>
);
